(function () {
  'use strict';

  var KLAVIYO_SUBSCRIPTIONS_URL = 'https://a.klaviyo.com/client/subscriptions';
  /** @see https://developers.klaviyo.com/en/reference/create_client_subscription */
  var KLAVIYO_REVISION = '2025-10-15';

  var MSG_EMAIL =
    'Please enter your email address.';
  var MSG_COMPANY_ID =
    'Sign-up is unavailable right now.';
  var MSG_LIST_ID =
    'Sign-up is unavailable right now.';

  /**
   * Public company_id from the Klaviyo onsite script (same as embed snippet).
   * @returns {string}
   */
  function getKlaviyoCompanyIdFromScript() {
    var el = document.querySelector('script[src*="klaviyo.js"]');
    if (!el || !el.src) {
      return '';
    }
    var after = el.src.split('company_id=')[1];
    if (!after) {
      return '';
    }
    return (after.split('&')[0] || '').trim();
  }

  /**
   * @param {HTMLFormElement} form
   * @param {string} message
   */
  function showFrontEndError(form, message) {
    var errEl = form.querySelector('.errors');
    if (errEl) {
      errEl.textContent = message;
    }
    form.classList.add('has-error');
    form.classList.remove('has-success');
  }

  /**
   * @param {HTMLFormElement} form
   */
  function clearFrontEndError(form) {
    var errEl = form.querySelector('.errors');
    if (errEl) {
      errEl.textContent = '';
    }
    form.classList.remove('has-error');
    form.classList.remove('has-success');
  }

  if (!customElements.get('klaviyo-newsletter-form')) {
    customElements.define(
      'klaviyo-newsletter-form',
      class KlaviyoNewsletterForm extends HTMLElement {
        constructor() {
          super();
          this.newsletter = null;
          this.inputs = [];
          this.popup = null;
          this.handleSubmit = function (e) {
            this.onSubmit(e);
          }.bind(this);
          this.refreshRefs();
        }

        connectedCallback() {
          /** Capture on host so we run before bubble listeners on the form (avoids being pre-empted). */
          this.removeEventListener('submit', this.handleSubmit, true);
          this.addEventListener('submit', this.handleSubmit, true);
          this.refreshRefs();
          if (!this.newsletter) {
            console.warn(
              'klaviyo-newsletter-form: expected a child form.newsletter-form inside <klaviyo-newsletter-form>'
            );
          }
        }

        disconnectedCallback() {
          this.removeEventListener('submit', this.handleSubmit, true);
        }

        refreshRefs() {
          this.newsletter = this.querySelector('form.newsletter-form');
          this.inputs = this.newsletter
            ? Array.from(
                this.newsletter.querySelectorAll('input, select, textarea')
              )
            : [];
          this.popup = this.newsletter && this.newsletter.closest
            ? this.newsletter.closest('[data-popup]')
            : null;
        }

        /**
         * @param {Event} event
         */
        onSubmit(event) {
          this.refreshRefs();
          var form = this.newsletter;
          if (
            !form ||
            event.target !== form ||
            !(event.target instanceof HTMLFormElement)
          ) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          clearFrontEndError(form);

          var companyId = getKlaviyoCompanyIdFromScript();
          var listId = this.getAttribute('data-klaviyo-list-id') || '';

          var fd = new FormData(form);
          var email = String(fd.get('contact[email]') || '').trim();
          var firstName = String(fd.get('contact[first_name]') || '').trim();
          var lastName = String(fd.get('contact[last_name]') || '').trim();

          if (!email) {
            console.error(
              '[klaviyo-newsletter-form] email: missing or empty contact[email]'
            );
            showFrontEndError(form, MSG_EMAIL);
            return;
          }

          if (!companyId) {
            console.error(
              '[klaviyo-newsletter-form] companyId: could not parse company_id from a script matching [src*="klaviyo.js"]'
            );
            showFrontEndError(form, MSG_COMPANY_ID);
            return;
          }

          if (!listId) {
            console.error(
              '[klaviyo-newsletter-form] listId: missing or empty data-klaviyo-list-id on <klaviyo-newsletter-form>'
            );
            showFrontEndError(form, MSG_LIST_ID);
            return;
          }

          var profileAttributes = {
            email: email,
            subscriptions: {
              email: {
                marketing: {
                  consent: 'SUBSCRIBED',
                },
              },
            },
          };

          if (firstName) {
            profileAttributes.first_name = firstName;
          }
          if (lastName) {
            profileAttributes.last_name = lastName;
          }

          var payload = {
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: profileAttributes,
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: listId,
                  },
                },
              },
            },
          };

          var url =
            KLAVIYO_SUBSCRIPTIONS_URL +
            '?company_id=' +
            encodeURIComponent(companyId);

          fetch(url, {
            method: 'POST',
            headers: {
              'content-type': 'application/vnd.api+json',
              accept: 'application/vnd.api+json',
              revision: KLAVIYO_REVISION,
            },
            body: JSON.stringify(payload),
          })
            .then(function (res) {
              if (res.ok || res.status === 202) {
                clearFrontEndError(form);
                form.classList.add('has-success');
                form.reset();
                return;
              }
              console.error(
                '[klaviyo-newsletter-form] API error:',
                res.status,
                res.statusText
              );
              showFrontEndError(
                form,
                'Something went wrong. Please try again later.'
              );
            })
            .catch(function (err) {
              console.error('[klaviyo-newsletter-form]', err);
              showFrontEndError(
                form,
                'Something went wrong. Please try again later.'
              );
            });
        }
      }
    );
  }
})();
